export const getUserStats = ({ stats }) => {
  const { filteredOutUsers, userStats } = stats

  const filterFn = ({ id, status }) => !filteredOutUsers.includes(id + status)

  return userStats.filter(filterFn)
}
